import React, { useEffect, useState } from 'react';
import styles from './DistributorCreateEdit.module.scss';

import api from '../../helpers/api';
import { $t } from '../../helpers/translator';
import _ from "lodash";
import { setAlert } from "../../store/alerts-slice";
import MultiSelect from '../miscellaneous/MultiSelect/MultiSelect';
import { getCountries } from "../../store/data-slice";
import { useDispatch } from "react-redux";

const DistributorCreateEdit = (props) => {
    const dispatch = useDispatch();
    const fields = {
        name: '',
        phone: '',
        country: '',
        address: '',
        email: '',
        password: ''
    }
    const [ distributor, setDistributor ] = useState(props.distributorData ? {
        id: props.distributorData.id,
        name: props.distributorData.name,
        phone: props.distributorData.phone,
        country: props.distributorData.country,
        address: props.distributorData.address,
        email: props.distributorData.email,
        password: null
    } : fields);
    const [ fieldErrors, setFieldErrors ] = useState(fields)
    const [ errorText, setErrorText ] = useState('');
    const [ isSuccess, setIsSuccess ] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);

    const { mode, userType } = props;

    useEffect(() => {
        loadCountries();
    }, [])

    const loadCountries = async() => {
        try {
            let res = await dispatch(getCountries());
            if (res) {
                setCountryOptions(res);
            }
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }



    const getSelectedCountries = (ids) => {
        const selected = countryOptions.filter((c) => {
            return ids.includes(c.id)
        }).map((c) => {
            return {
                label: $t('countries.' + c.name),
                value: c.id
            }
        })

       return selected;
    }

    const handleInputChange = (event) => {
        const target = event.target;
        setDistributor({
            ...distributor,
            [target.name]: target.value
        });
        setFieldErrors({
            ...fieldErrors,
            [target.name]: ''
        })
    }

    const sendForm = async () => {
        setErrorText('');
        const validated = validateForm();
        // console.log(validated);
        if (!validated) {
            return;
        }

        let payload = {
            ...distributor,
        }

        try {
            let res = {};
            if (mode === 'create') {
                res = await api.post('distributor/new', payload);
            } else {
                res = await api.patch(`distributor/${payload.id}`, payload);
            }

            if (res.data && res.data.success) {
                // console.log('success!');
                let successText = mode === 'create' ? $t('global.distributors.distributorCreatedSuccessfully') : $t('global.distributors.distributorUpdatedSuccessfully')
                dispatch(setAlert({ type: 'success', body: successText }));
                setIsSuccess(true);
                emitSuccess(payload)
            } else {
                let errorText = $t('validation.general.errorOccurred');
                const response = res.response.data;
                if (response.errors.length > 0) {
                    errorText = response.errors[ 0 ].error;
                }
                setErrorText(errorText);
            }
        } catch (e) {
            console.error('error: ', e);
            let errorText = $t('validation.general.errorOccurred');
            dispatch(setAlert({ type: 'error', body: errorText }));
            setErrorText(errorText);
        }
    }

    const validateForm = () => {
        let newFieldErrors = { ...fieldErrors };
        let validated = true;

        _.forEach(newFieldErrors, (v, k) => {
            if (distributor[ k ] === '' || distributor[ k ] === null) {
                newFieldErrors[ k ] = $t('validation.general.required');
                validated = false;
            }
        });

        setFieldErrors(newFieldErrors);
        return validated;
    }

    /**
     * emitting success and data for parent to update accordingly
     * @param patient
     */
    const emitSuccess = (d) => {
        props.onSuccess({
            success: true,
            mode: mode,
            distributor: d
        });
    }

    return (
        <div className={ `${styles[ 'container' ]}` } style={{minWidth: '40vw'}}>
            <div>
                <div className={ `${styles[ 'header' ]}` }>{ mode === 'edit' ? $t('global.distributors.editDistributor') : $t('global.distributors.addNewDistributor') }</div>

                <div className={ `${styles[ 'fields-row' ]}` }>
                    <div className={ `${styles[ 'field-container' ]}` }>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.name') }</div>
                        <div className={ `${styles[ 'field-input-max' ]}` }>
                            <input className={ 'alma-input full' }
                                name="name" type="text"
                                value={ distributor.name }
                                placeholder={ $t('global.distributors.placeholders.name') }
                                onChange={ (e) => handleInputChange(e) } />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.name }
                        </div>
                    </div>
                    <div className={ `${styles[ 'field-container' ]}` } style={{maxWidth: '350px'}}>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.country') }</div>
                        <div className={ `${styles[ 'field-input' ]}` }>
                            <MultiSelect
                                multi={true}
                                width={'100%'}
                                searchable
                                options={countryOptions}
                                placeholder={$t('global.account.country')}
                                onValueChange={(data) => {
                                    const countryIds = Object.values(data).map((d) => {
                                        return d.value;
                                    })

                                    setDistributor({...distributor, country: countryIds}); setFieldErrors({
                                    ...fieldErrors,
                                    country: ''
                                })}}
                                selected={getSelectedCountries(distributor.country)}
                            />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.country }
                        </div>
                    </div>
                </div>

                <div className={ `${styles[ 'fields-row' ]}` }>
                    <div className={ `${styles[ 'field-container' ]}` }>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.email') }</div>
                        <div className={ `${styles[ 'field-input' ]}` }>
                            <input className={ 'alma-input full' }
                                name="email" type="email"
                                value={ distributor.email }
                                placeholder={ $t('global.distributors.placeholders.email') }
                                onChange={ (e) => handleInputChange(e) } />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.email }
                        </div>
                    </div>
                    <div className={ `${styles[ 'field-container' ]}` }>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.password') }</div>
                        <div className={ `${styles[ 'field-input' ]}` }>
                            <input className={ 'alma-input full' }
                                name="password" type="password"
                                value={ distributor.password }
                                placeholder={ $t('global.distributors.placeholders.password') }
                                onChange={ (e) => handleInputChange(e) } />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.password }
                        </div>
                    </div>
                </div>

                <div className={ `${styles[ 'fields-row' ]}` }>
                    <div className={ `${styles[ 'field-container' ]}` }>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.phone') }</div>
                        <div className={ `${styles[ 'field-input' ]}` }>
                            <input className={ 'alma-input full' }
                                name="phone" type="text"
                                value={ distributor.phone }
                                placeholder={ $t('global.distributors.placeholders.phone') }
                                onChange={ (e) => handleInputChange(e) } />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.phone }
                        </div>
                    </div>
                    <div className={ `${styles[ 'field-container' ]}` }>
                        <div className={ `${styles[ 'field-name' ]}` }>{ $t('global.distributors.address') }</div>
                        <div className={ `${styles[ 'field-input' ]}` }>
                            <input className={ 'alma-input full' }
                                name="address" type="text"
                                value={ distributor.address }
                                placeholder={ $t('global.distributors.placeholders.address') }
                                onChange={ (e) => handleInputChange(e) } />
                        </div>
                        <div className={ `${styles[ 'field-error' ]}` }>
                            { fieldErrors.address }
                        </div>
                    </div>
                </div>

                <div className={ `${styles[ 'fields-row' ]}` }>
                    
                </div>

                <div className={ `${styles[ 'button-row' ]}` }>
                    <div className={ 'alma-button' } onClick={ () => sendForm() }>{ mode === 'edit' ? $t('global.distributors.editDistributor') : $t('global.distributors.addDistributor') }</div>

                </div>

                <div className={ `${styles[ 'error-row' ]}` }>
                    <div>{ errorText }</div>
                </div>
            </div>
            {/*}*/ }
        </div>
    );

}

export default DistributorCreateEdit;
